import { dashboard } from '@wix/dashboard';
import { createClient } from '@wix/sdk';

let dashboardClient: ReturnType<typeof createDashboardClient> | null = null;

const createDashboardClient = () => {
  const client = createClient({
    host: dashboard.host(),
    auth: dashboard.auth(),
  });
  (globalThis as { __wix_context__?: { client: typeof client } }).__wix_context__ = { client };
  return client;
};

export const getDashboardClient = () => {
  if (!dashboardClient) {
    dashboardClient = createDashboardClient();
  }
  return dashboardClient;
};

export const getDashboardAccessToken = async (): Promise<string> => {
  getDashboardClient();
  return await dashboard.getAccessToken();
};
